<template>
  <div class="home">
    <HelloWorld/>
    <FooterContent/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import FooterContent from '@/components/Footer.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld,
    FooterContent
  }
}
</script>
